import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {FrapperService} from "./frapper.service";
import {AssignedService} from "./assigned.service";
import { AuthService } from '../auth/auth.service';


@Injectable({
  providedIn: 'root'
})
export class SignatairesService {

  Doctype_Default_Signataire ='default_signataire'
  Doctype_casier = 'casier'

  constructor(private http: HttpClient, private frapper: FrapperService,private authservice: AuthService, private assigneService:AssignedService) {}


  async getAllDefaultsSignataires(filter=null){
    try{
      let documents = await this.frapper.GetDoctypes(this.Doctype_Default_Signataire, '["*"]', filter).toPromise();
      return documents;
    }catch(error){
      this.authservice.handleError(error)
      console.error(error)
    }
  }

  async getOneDefaultSignataire(name){
    try{
      let document = await this.frapper.GetDoctype(this.Doctype_Default_Signataire,name,'["*"]',null).toPromise();
      return document;
    }catch(error){
      this.authservice.handleError(error);
    }
  }


  async newDefaulSignataire(body){
    try{
      let new_document = await this.frapper.CreateDoctype(this.Doctype_Default_Signataire,body).toPromise();
      return new_document;
    }catch(error){
      this.authservice.handleError(error);
    }

  }

  async updateDefaulSignataire(docname, body){
    try{
      let result = await this.frapper.UpdateDoctype(this.Doctype_Default_Signataire,docname,body).toPromise();
      return result;
    }catch(error){
      this.authservice.handleError(error)
    }
  }


}
